export const AD_APPROVAL_BEHAVIOR_MANUAL = 'manual';
export const AD_APPROVAL_BEHAVIOR_AUTOMATIC = 'automatic';
